export const MAX_IMPORT_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const PDF_EXTENSION = '.pdf';

export const ACCEPTED_FILE_EXTENSIONS = [PDF_EXTENSION, '.docx', '.doc'];

export const SENTENCE_END = /[.!?:;]["'’”)\]]*$/;

export const HEADING_SIZE_RATIO = 1.15;

export const SAME_X_TOLERANCE_PT = 1.5;

// Word's single line at its default body font, as Chromium renders it
export const WORD_BLANK_LINE_PT = 11.5;
